// Editable registration suggestions only, never identity verification or OAuth claims validation.
const object = (value) =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {};
function text(value, max = 256) {
  if (typeof value !== 'string' || value.length > max) return '';
  return value
    .replace(/\p{Cc}/gu, ' ')
    .replace(/\s+/gu, ' ')
    .trim();
}
function pick(profiles, keys, normalize = text) {
  for (const profile of profiles)
    for (const key of keys) {
      const value = normalize(profile[key]);
      if (value) return value;
    }
  return '';
}
function phone(value) {
  const candidate = text(value, 80);
  const digits = candidate.replace(/\D/g, '');
  return /^\+?[\d\s()-]+$/.test(candidate) &&
    digits.length >= 7 &&
    digits.length <= 15
    ? candidate
    : '';
}
function gender(value) {
  const v = text(value, 32).toLowerCase();
  if (v === 'm' || v === 'male') return 'm';
  if (v === 'f' || v === 'female') return 'f';
  return '';
}
function avatar(value) {
  const candidate = text(value, 2048);
  if (
    candidate.startsWith('/') &&
    !candidate.startsWith('//') &&
    !candidate.includes('\\')
  )
    return candidate;
  try {
    const url = new URL(candidate);
    return url.protocol === 'https:' && !url.username && !url.password
      ? url.href
      : '';
  } catch {
    return '';
  }
}
export function normalizeSocialPrefill(...sources) {
  const profiles = sources.map(object);
  const names = profiles.flatMap((profile) => [
    profile,
    object(profile.name),
    object(profile.fullName)
  ]);
  let first_name = pick(names, [
    'first_name',
    'firstName',
    'given_name',
    'givenName'
  ]);
  let last_name = pick(names, [
    'last_name',
    'lastName',
    'family_name',
    'familyName'
  ]);
  const name = pick(
    profiles,
    ['name', 'full_name', 'fullName', 'displayName'],
    (value) => text(value, 512)
  );
  if (!first_name && !last_name && name) {
    const parts = name.split(' ');
    first_name = parts.shift();
    last_name = parts.join(' ');
  } else if (!last_name && first_name && name.startsWith(first_name + ' ')) {
    last_name = name.slice(first_name.length + 1);
  } else if (!first_name && last_name && name.endsWith(' ' + last_name)) {
    first_name = name.slice(0, -last_name.length - 1);
  }
  return {
    first_name,
    last_name,
    name,
    email: pick(profiles, ['email'], (value) => {
      const v = text(value, 254);
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? v : '';
    }),
    phone: pick(
      profiles,
      ['phone', 'phone_number', 'phoneNumber', 'mobile'],
      phone
    ),
    gender: pick(profiles, ['gender', 'sex'], gender),
    avatar: pick(profiles, ['avatar', 'picture'], avatar)
  };
}
export const socialPrefillFields = Object.freeze([
  'first_name',
  'last_name',
  'email',
  'phone',
  'gender'
]);
export function applySocialPrefill(form, prefill, edited = new Set()) {
  for (const field of socialPrefillFields) {
    if (
      !edited.has(field) &&
      !String(form[field] || '').trim() &&
      prefill[field]
    )
      form[field] = prefill[field];
  }
}
